import { atom } from 'jotai'
import { atomWithListeners, LifecycleState, PersistenceState } from '../../utilities'
import { ConformedCampaignReview } from '../../views'

export const [campaignReviewAtom, useCampaignReviewListener] = atomWithListeners<
	ConformedCampaignReview | undefined
>(undefined)

export const campaignReviewStatusAtom = atom<LifecycleState>('idle')
export const campaignReviewSavingAtom = atom<PersistenceState>('idle')
